export default "__VITE_ASSET__CljYiBMf__"